// extracted by mini-css-extract-plugin
export var dropdownContainer = "_o2-0";
export var leftAlign = "_o2-4";
export var listItem = "_o2-2";
export var listItemWrapper = "_o2-1";
export var operationText = "_o2-3";